import { GroupBase, StylesConfig } from "react-select";
import { defaultStyles } from "react-select/dist/declarations/src/styles";
import Option from "../../interfaces/Option/Option";

export const formFieldSelectStylesForProductPropertiesOverlay: StylesConfig<Option, boolean, GroupBase<Option>> = {
    container: (defaultStyles, state) => ({
        ...defaultStyles,
        width: '100%',
    }),
    control: (defaultStyles, state) => ({
        ...defaultStyles,
        border: 'none',
        borderBottom: '1px solid #b8b8b8',
        borderRadius: 'none',
        flexDirection: 'row-reverse',
        boxShadow: 'none',
        backgroundColor: 'transparent',
        "&:hover": {
            borderBottom: '1px solid #b8b8b8',
        }
    }),
    menu: (defaultStyles, state) => ({
        ...defaultStyles,
        maxHeight: '11rem',
        marginTop: 0,
        borderRadius: 0,
    }),
    menuList: (defaultStyles, state) => ({
        ...defaultStyles,
        maxHeight: '11rem',
        scrollbarWidth: 'thin',
        padding: '15px 0',
        "::-webkit-scrollbar": {
            width: '6px',
        },
        "::-webkit-scrollbar-thumb": {
            backgroundColor: '#cdcdcd',
            borderRadius: 0,
        },
        "::-webkit-scrollbar-track": {
            backgroundColor: '#f1eeed',
            borderRadius: 0,
        }
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    indicatorsContainer: (defaultStyles, state) => ({
        ...defaultStyles,
        padding: 'none',
    }),
    valueContainer: (defaultStyles, state) => ({
        ...defaultStyles,
        paddingLeft: 0,
    }),
    option: (defaultStyles, state) => ({
        ...defaultStyles,
        backgroundColor: state.isFocused ? '#f4f4f4' : state.isSelected ? '#ececec' : 'none',
        color: '#3D323B',
        fontWeight: state.isSelected || state.isFocused ? 'bold' : 'lighter',
        padding: '5px 30px'
    }),
};

export const formFieldSelectStylesForCustomerDataPage: StylesConfig<Option, boolean, GroupBase<Option>> = {
    container: (defaultStyles, state) => ({
        ...defaultStyles,
        width: '100%',
        // margin: state.isFocused ? '0 -1rem' : 0,
        // padding: state.isFocused ? '0 1rem' : 0,
        // backgroundColor: state.isFocused ? 'white' : 'transparent',
    }),
    control: (defaultStyles, state) => ({
        ...defaultStyles,
        border: 'none',
        borderBottom: '1px solid #6b6b6b',
        borderRadius: 'none',
        boxShadow: 'none',
        backgroundColor: 'transparent',
        minHeight: 'auto',
        "&:hover": {
            borderBottom: '1px solid #6b6b6b',
        }
    }),
    menu: (defaultStyles, selectProps) => ({
        ...defaultStyles,
        maxHeight: '15rem',
        borderRadius: 0,
        // marginLeft: '-1rem',
        // boxShadow: 'none',
        marginTop: 0,
        zIndex: '2',
    }),
    menuList: (defaultStyles, state) => ({
        ...defaultStyles,
        maxHeight: '15rem',
        scrollbarWidth: 'thin',
        "::-webkit-scrollbar": {
            width: '6px',
        },
        "::-webkit-scrollbar-thumb": {
            backgroundColor: '#cdcdcd',
            borderRadius: 0,
        },
        "::-webkit-scrollbar-track": {
            backgroundColor: '#f1eeed',
            borderRadius: 0,
        }
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    indicatorsContainer: (defaultStyles, state) => ({
        ...defaultStyles,
        padding: 'none',
    }),
    dropdownIndicator: (defaultStyles, state) => ({
        position: 'absolute',
        left: 0,
        padding: 0,
        overflow: 'hidden',
    }),
    valueContainer: (defaultStyles, state) => ({
        ...defaultStyles,
        paddingLeft: '30px',
        paddingBottom: 0,
    }),
    input: (defaultStyles, state) => ({
        ...defaultStyles,
        paddingBottom: 0,
        margin: 0,
        visibility: 'visible',
        "> input": {
            // Opacity is extrem important to show the selected value
            // if it's not set the selected value is for any reason hidden
            opacity: '1 !important',
            gridColumnEnd: '4 !important',
            marginBottom: '3px !important',
        },
        "::placeholder": {
            color: '#3D323B'
        }
    }),
    option: (defaultStyles, state) => ({
        ...defaultStyles,
        backgroundColor: state.isSelected ? '#ececec' : state.isFocused ? '#f4f4f4' : 'none',
        color: '#3D323B',
        fontWeight: state.isSelected || state.isFocused ? 'bold' : 'lighter',
        padding: '5px 30px'
    }),
    multiValue: (defaultStyles, state) => ({
        ...defaultStyles,
        backgroundColor: 'hsl(0, 0%, 80%)',
        marginTop: '7.5px',
    }),
    multiValueLabel: (defaultStyles, state) => ({
        ...defaultStyles,
        paddingTop: 0,
        paddingBottom: 0,
    }),
    singleValue: (defaultStyles, state) => ({
        ...defaultStyles,
        color: 'rgb(51, 51, 51)',
    }),
    placeholder: (defaultStyles, state) => ({
        ...defaultStyles,
        color: '#3D323B',
    }),
    menuPortal: (defaultStyles, state) => ({
        ...defaultStyles,
        zIndex: '99',
    }),
}
